import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminstrationComponent } from './components/adminstration/adminstration.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { HomeComponent } from './components/home/home.component';
import { OrderSummaryComponent } from './components/order-summary/order-summary.component';
import { ReceiptConfirmationComponent } from './components/order-summary/receipt-confirmation/receipt-confirmation.component';
import { ReportsComponent } from './components/reports/reports.component';
import { DcMaintainenceComponent } from './components/adminstration/dc-maintainence/dc-maintainence.component';
import { OrderConfirmationComponent } from './components/order-summary/order-confirmation/order-confirmation.component';
import { StoreMaintainenceComponent } from './components/adminstration/store-maintainence/store-maintainence.component';
import { ReceiptConfirmationDiscrepancyComponent } from './components/order-summary/receipt-confirmation-discrepancy/receipt-confirmation-discrepancy.component';
import { ReceiptConfirmationDetailsComponent } from './components/order-summary/receipt-confirmation-details/receipt-confirmation-details.component';
import { OrderConfirmationDetailsComponent } from './components/order-summary/order-confirmation-details/order-confirmation-details.component';
import { StoreUsersComponent } from './components/adminstration/store-users/store-users.component';
import { DcUsersComponent } from './components/adminstration/dc-users/dc-users.component';
import { AddEditStoreUserComponent } from './components/adminstration/add-edit-store-user/add-edit-store-user.component';
import { AddEditDcUserComponent } from './components/adminstration/add-edit-dc-user/add-edit-dc-user.component';
import { ElectronicSignatureAttestationComponent } from './components/electronic-signature-attestation/electronic-signature-attestation.component';
import { EditStoreComponent } from './components/adminstration/edit-store/edit-store.component';
import { EditDcComponent } from './components/adminstration/edit-dc/edit-dc.component';
import { StoreManagementComponent } from './components/store-management/store-management.component';
import { OrderMaintainenceComponent } from './components/order-maintainence/order-maintainence.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { ApproveDialogComponent } from './components/approve-dialog/approve-dialog.component';

import { AuthGuardSsoService } from "./services/auth-guard-sso.service";
import { CallBackComponent } from './components/call-back/call-back.component';
import { SignedOcReportComponent } from './components/reports/signed-oc-report/signed-oc-report.component';
import { UnSignedPackagesComponent } from './components/reports/un-signed-packages/un-signed-packages.component';
import { MarReportComponent } from './components/reports/mar-report/mar-report.component';
import { MissingSignatureReportComponent } from './components/reports/missing-signature-report/missing-signature-report.component';
import { ExceptionReportComponent } from './components/reports/exception-report/exception-report.component';
import { ElectronicSignatureAttestationReportComponent } from './components/reports/electronic-signature-attestation-report/electronic-signature-attestation-report.component';
import { CurrentUserResolver } from './components/shared/current-user-resolver';
import { LogoutComponent } from './components/logout/logout.component';
import { DcnEsignHomeComponent } from './components/dcn-esign-home/dcn-esign-home.component';
import { ProtectedComponent } from './components/protected/protected.component';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { MsalRedirectComponent } from './components/msal-redirect/msal-redirect.component';

// Allow /redirect to navigate inside popup so the MSAL bridge component can run
const isMsalRedirectPage = window.location.pathname.indexOf('/redirect') === 0;
const initialNavigation =
  (!BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()) || isMsalRedirectPage
    ? 'enabledBlocking'
    : 'disabled';

const routes: Routes = [
  // MSAL v5 popup/iframe bridge — must stay outside AuthGuardSsoService / MsalGuard
  { path: 'redirect', component: MsalRedirectComponent },
  {
    
    path: 'dcn-esign', canActivate:  [AuthGuardSsoService], component: HomeComponent, runGuardsAndResolvers: 'always',
    //  resolve: {
    //    loggedInUser: CurrentUserResolver
    //  } ,
    children: [
     
      { path: '', pathMatch: 'full', runGuardsAndResolvers: 'always', redirectTo: 'dashboard' },
      { path: 'dashboard', runGuardsAndResolvers: 'always', component: DashboardComponent, data: { label: 'Dashboard' } },
    

      {
        path: 'order-summary', runGuardsAndResolvers: 'always', component: OrderMaintainenceComponent, data: { label: 'Order Summary' },

        children: [
          { path: '', pathMatch: 'full', redirectTo: 'order-details' },
          { path: 'order-details', component: OrderSummaryComponent},
          { path: 'order-details/:dc-store-number', component: OrderSummaryComponent},
          { path: 'order-confirmation/:sequenceNo',  component: OrderConfirmationDetailsComponent,
      
          children: [
                  { path: '', pathMatch: 'full', redirectTo: 'order-confirmation' },
                  { path: 'order-confirmation', component: OrderConfirmationComponent }]
        },
        
          {
            path: 'receipt-confirmation/:sequenceNo', component: ReceiptConfirmationDetailsComponent,
            children: [
                    { path: '', pathMatch: 'full', redirectTo: 'receipt-confirmation-details' },
                    { path: 'receipt-confirmation-details', component: ReceiptConfirmationComponent },
                    { path: 'update-discrepancy/:udsequenceNo', component: ReceiptConfirmationDiscrepancyComponent }
                  ]
          },
       
          { path: 'receipt-confirmation', component: ReceiptConfirmationDetailsComponent, data: { label: 'Receipt Confirmation' } },
          {
            path: 'order-confirmation-details/:sequenceNo', component: OrderConfirmationDetailsComponent
            , children: [
              { path: '', pathMatch: 'full', redirectTo: 'order-confirmation' },
              { path: 'order-confirmation', component: OrderConfirmationComponent }
            ]
          },
        ]
      },

      {
        path: 'order-summary/:dc-store-number', component: OrderMaintainenceComponent, children : [
          { path: '', pathMatch: 'full', redirectTo: 'order-details' },
          {path: 'order-details', component: OrderSummaryComponent},
          {path: 'order-details/:dc-store-number', component: OrderSummaryComponent},
          {path: 'order-summary-details/:dc-store-number', component: OrderSummaryComponent},
          { path: 'order-confirmation/:sequenceNo',  component: OrderConfirmationDetailsComponent}
        ],
      },
     
      { path: 'reports', component: ReportsComponent, data: { label: 'Reports' } ,children : [
        { path: '', pathMatch: 'full', redirectTo: 'signed-orders-reports' },
        { path: 'signed-orders-report',  pathMatch: 'full',    component: SignedOcReportComponent },
        { path: 'unsigned-packages-report',  pathMatch: 'full',    component: UnSignedPackagesComponent },
        { path: 'mar-report',  pathMatch: 'full',    component: MarReportComponent },
        { path: 'missing-signature-report',  pathMatch: 'full',    component:MissingSignatureReportComponent  },
        { path: 'exception-report',  pathMatch: 'full',    component: ExceptionReportComponent },
        { path: 'esa-report',  pathMatch: 'full',    component: ElectronicSignatureAttestationReportComponent }

      ] },
      {
        path: 'administration', component: AdminstrationComponent, data: { label: 'Administration' }, children: [
          { path: '', pathMatch: 'full', redirectTo: 'dc-users' },
          { path: 'dc-users', pathMatch: 'full', component: DcUsersComponent },
          { path: 'dc-users/:dcNumber', pathMatch: 'full', component: DcUsersComponent },
          { path: 'add-edit-dc-user', pathMatch: 'full', component: AddEditDcUserComponent },
          { path: 'add-edit-dc-user/:upn', pathMatch: 'full', component: AddEditDcUserComponent },
          { path: 'dc-maintainence', component: DcMaintainenceComponent },
          { path: 'edit-dc/:dcNumber', component: EditDcComponent }

        ]
      },
      {
        path: 'store-management', data: { label: 'Store Management' }, component: StoreManagementComponent, children: [
          { path: '', pathMatch: 'full', redirectTo: 'store-users' },
          { path: 'store-users', component: StoreUsersComponent },
          { path: 'store-users/:storeNumber', component: StoreUsersComponent },
          { path: 'add-edit-store-user', pathMatch: 'full', component: AddEditStoreUserComponent },
          { path: 'add-edit-store-user/:upn', pathMatch: 'full', component: AddEditStoreUserComponent },
          { path: 'store-maintainence', component: StoreMaintainenceComponent },
          { path: 'edit-store/:sequence', component: EditStoreComponent }
        ]
      },
     
      { path: 'my-profile-dc', component: AddEditDcUserComponent },
      { path: 'my-profile-dc/:upn', component: AddEditDcUserComponent },
      { path: 'my-profile-store/:upn', component: AddEditStoreUserComponent },
      // { path: 'unauthorized', component: UnauthorizedComponent },
      { path: 're-auth', component: ApproveDialogComponent , canActivate: [
        MsalGuard
      ]  },
    ]
  },
  { path: 'auth-home',  component:DcnEsignHomeComponent},
  // { path: '', component:DcnEsignHomeComponent},
  { path: '', pathMatch: 'full', redirectTo: '/sso'},
  { path: 'logoutapp', component: LogoutComponent},
  { path: 'unauthorized', component: UnauthorizedComponent},
  { path: 'esa', component: ElectronicSignatureAttestationComponent, canActivate:  [AuthGuardSsoService],runGuardsAndResolvers: 'always'},
  { path: 'sso', component: ProtectedComponent, canActivate:  [AuthGuardSsoService]},
  { path: 'auth-callback', component: CallBackComponent},
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ onSameUrlNavigation: 'reload', useHash: false,
    initialNavigation })],
  exports: [RouterModule],
  providers: [CurrentUserResolver]
})
export class AppRoutingModule { }
